import './assets/index.css'

import 'vue-base-tooltip/style.css'
import '@fontsource/clear-sans/latin.css'
import '@fontsource/jetbrains-mono'
import 'flowbite'
import 'maplibre-gl/dist/maplibre-gl.css'

import App from './App.vue'
import { createApp } from 'vue'
import Pusher from '@/plugins/Pusher'

import router from './router'
import { createPinia } from 'pinia'
import { Env } from '@/util/Env'
import { visible } from '@/util/Visible'
import VueMitter from '@nguyenshort/vue3-mitt'

import * as Sentry from '@sentry/vue'
import { PromiseDialog } from 'vue3-promise-dialog'
import { createHead } from '@vueuse/head'
import VueGuidedTour from 'vue-guided-tour'
import { autoAnimatePlugin } from '@formkit/auto-animate/vue'
import VueLazyLoad from 'vue3-lazyload'

import VueBaseTooltip from 'vue-base-tooltip'
import { Replay } from '@sentry/replay'
import Notifications from 'notiwind'
import Nl2br from 'vue3-nl2br'
import GoogleSignInPlugin from 'vue3-google-signin'
import VueBlurHash from 'another-vue3-blurhash'
import { Validations } from '@/util/Validations.ts'
import { install as VueMonacoEditorPlugin } from '@guolao/vue-monaco-editor'
import pjson from '../package.json'
import Chart from 'vue-frappe-chart'

const app = createApp(App)
app.use(VueMonacoEditorPlugin, {
  paths: {
    // The recommended CDN config
    vs: 'https://cdn.jsdelivr.net/npm/monaco-editor@0.43.0/min/vs'
  }
})

const pinia = createPinia()
const head = createHead({
  titleTemplate: (title) => `${title} | TOURISM Network`
})

Validations()

app.use(VueLazyLoad, {
  loading: '',
  error: ''
})

app.use(router)
app.use(pinia)
app.use(Pusher)
app.use(Chart)
app.use(head)
app.use(VueGuidedTour)
app.use(autoAnimatePlugin)
app.use(Notifications)
app.use(VueBaseTooltip)
app.use(VueBlurHash)
app.use(VueMitter)

app.component('Nl2br', Nl2br)

app.directive('visible', visible)

app.use(GoogleSignInPlugin, {
  clientId: Env('GAPI_CLIENT_ID')
})

if (Env('SENTRY_ENABLED') === 'true') {
  Sentry.init({
    app,
    dsn: Env('SENTRY_DSN'),
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 1.0,
    release: 'obu-client@' + pjson.version,
    replaysOnErrorSampleRate: 1.0,
    integrations: [new Replay({
      maskAllText: false,
      maskAllInputs: false,
      blockAllMedia: false,
      maskInputOptions: { password: true }
    })]
  })
} else {
  app.config.errorHandler = (err, instance, info) => {
    console.log('ERROR HANDLER', err, instance, info)
  }
}

app.mount('#app')
